const CLIENT_VISUAL_MODEL_BY_ID = {
    '1761594622012': 'opella',
    '1761594622013': 'opella',
};

const RULE_MODEL_INHERITANCE = {
    opella: 'sanofi',
};

const toComparableId = (value) => {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    if (typeof value === 'object') {
        const objectId = value?.id ?? value?.value ?? null;
        if (objectId === null || objectId === undefined || objectId === '' || typeof objectId === 'object') {
            return null;
        }

        return String(objectId);
    }

    return String(value);
};

const normalizeText = (text) =>
    (text || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .trim();

const normalizeModel = (model) => (model || '').toString().trim().toLowerCase();

const resolveOrcamentoClientVisualModel = (cliente = null) => {
    const clienteId = toComparableId(cliente?.id ?? cliente);
    if (clienteId && CLIENT_VISUAL_MODEL_BY_ID[clienteId]) {
        return CLIENT_VISUAL_MODEL_BY_ID[clienteId];
    }

    const explicitModel = normalizeModel(cliente?.modelo);
    if (explicitModel === 'opella') {
        return 'opella';
    }

    const searchText = normalizeText([
        cliente?.nome,
        cliente?.nomefantasia,
        cliente?.identificacao,
    ].filter(Boolean).join(' '));

    if (searchText.includes('OPELLA')) {
        return 'opella';
    }

    if (explicitModel) {
        return explicitModel;
    }

    if (searchText.includes('SANOFI')) {
        return 'sanofi';
    }

    return 'master';
};

const resolveOrcamentoClientRuleModel = (cliente = null) => {
    let model = resolveOrcamentoClientVisualModel(cliente);
    const visited = new Set();

    while (RULE_MODEL_INHERITANCE[model] && !visited.has(model)) {
        visited.add(model);
        model = RULE_MODEL_INHERITANCE[model];
    }

    return model || 'master';
};

const usesSanofiBudgetRules = (cliente = null) => resolveOrcamentoClientRuleModel(cliente) === 'sanofi';

// Família Sanofi do evento (abas e resumo de BackOffice), igual à do back (OrcamentoClienteInheritance::
// resolveClienteModeloBase): inclui a Medley, pelos ids das filiais ou pelo modelo 'medley'. As regras de orçamento
// acima ainda não a incluem (ver feeBaseInternacionalPolicy), e incluí-la ali mudaria o fee do orçamento da Medley.
const MEDLEY_CLIENT_IDS = ['714943861777307814', '50228141783430569'];

const belongsToSanofiFamily = (cliente = null) => usesSanofiBudgetRules(cliente)
    || MEDLEY_CLIENT_IDS.includes(toComparableId(cliente?.id ?? cliente))
    || normalizeModel(cliente?.modelo) === 'medley';

export const OrcamentoClientInheritance = {
    resolveVisualModel: resolveOrcamentoClientVisualModel,
    resolveRuleModel: resolveOrcamentoClientRuleModel,
    usesSanofiBudgetRules,
    belongsToSanofiFamily,
};
